import styles from './style.module.css';
import React from 'react';

interface IButtonProps {
  handleclick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  buttonName?: string;
  style?: React.CSSProperties;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export const ButtonComponent: React.FC<IButtonProps> = ({ handleclick, buttonName, style, className, type = 'button', disabled = false }) => {
  return (
    <button type={type} className={`${styles.container} ${className || ''}`} onClick={handleclick} style={style} disabled={disabled}>
      <div className={styles.header}>{buttonName}</div>
    </button>
  );
};
